<template>
  <div class="align_left">
    <h3>
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Lien supplémentaires sur l'accueil
    </h3>
    <b-row v-if="links.length > 0">
      <b-col cols="12" v-for="(link, index) in links" :key="index">
        <LinksHomepageContainer
          :link="link"
          :index="index"
          :key="index"
          @shiftUpLink="shiftUpLink"
          @shiftDownLink="shiftDownLink"
          @deleteLink="deleteLink"
        ></LinksHomepageContainer>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col>
        <b-alert show variant="warning"
          >Aucun lien supplémentaire pour cet évènement, ajouter des élements
          via la bouton ci-dessous</b-alert
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="align_center" style="margin-top: 20px">
        <b-button class="button_save_admin" @click="addHomepageLink"
          >Ajouter un lien à la sidebar</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { HomepageLink } from "@/classes/HomepageLink.js";
import LinksHomepageContainer from "@/components/Admin_tab/Blocks/LinksHomepageContainer.vue";
export default {
  components: { HomepageLink,LinksHomepageContainer },
  props: ["extra_links"],
  data() {
      return {
          links: [],
      }
  },
  methods: {
    addHomepageLink() {
      this.links.push(new HomepageLink());
      this.$forceUpdate();
    },
        shiftUpLink(index) {
      var link = this.links[index];
      this.links.splice(index, 1);
      this.links.splice(index - 1, 0, link);
      this.$forceUpdate();
    },
    shiftDownLink(index) {
      var link = this.links[index];
      this.links.splice(index, 1);
      this.links.splice(index + 1, 0, link);
      this.$forceUpdate();
    },
    deleteLink(index) {
      this.links.splice(index, 1);
      this.$forceUpdate();
    },
  },
    mounted() {
    this.links = this.extra_links;
  },
};
</script>

<style lang="scss" scoped>
</style>